export default __webpack_public_path__ + "static/media/carrivnav.160b81cb.svg";